import { Signin } from 'views/signin';
import { Dashboard } from 'views/dashboard';
import { Accounts } from 'views/accounts';
import { Users } from 'views/users';
import { UserDetail } from 'views/userDetail';
import { Feedback } from 'views/feedback';
import { Support } from 'views/support';
import { Logs } from 'views/log/list';
import { LogDetail } from 'views/log/detail';
import { EventGroups } from 'views/event/groups';
import { Events } from 'views/event/list';
import { Alerts } from 'views/alerts';
import { EventDetail } from 'views/event/detail';
import { BundlePackaging } from 'views/bundlePackaging';
import { WorkspacesList } from 'views/workspacesList';
import { WorkspaceDetail } from 'views/workspaceDetails';
import { SignupPromotionalData } from 'views/signupPromotionalData';

const Routes = [
  {
    path: '/',
    view: Signin,
    layout: 'auth',
    title: 'Mission Control'
  },
  {
    path: '/signin',
    view: Signin,
    layout: 'auth',
    title: 'Mission Control'
  },
  {
    path: '/dashboard',
    view: Dashboard,
    layout: 'app',
    accountType: 'master',
    title: 'Dashboard'
  },
  {
    path: '/bundle-packaging',
    view: BundlePackaging,
    layout: 'app',
    accountType: 'master',
    title: 'Bundle Packaging'
  },
  {
    path: '/alerts',
    view: Alerts,
    layout: 'app',
    accountType: 'master',
    title: 'Alerts'
  },
  {
    path: '/feedback',
    view: Feedback,
    layout: 'app',
    accountType: 'master',
    title: 'Feedback'
  },
  {
    path: '/support',
    view: Support,
    layout: 'app',
    accountType: 'master',
    title: 'Support'
  },
  {
    path: '/signup-promotional-data',
    view: SignupPromotionalData,
    layout: 'app',
    accountType: 'master',
    title: 'Signup Promotional Data'
  },
  {
    path: '/logs',
    view: Logs,
    layout: 'app',
    accountType: 'master',
    title: 'Logs'
  },
  {
    path: '/logs/:id',
    view: LogDetail,
    layout: 'app',
    accountType: 'master',
    title: 'Log Detail'
  },
  {
    path: '/events',
    view: EventGroups,
    layout: 'app',
    accountType: 'master',
    title: 'Events'
  },
  {
    path: '/events/:group',
    view: Events,
    layout: 'app',
    accountType: 'master',
    title: 'Events'
  },
  {
    path: '/events/:group/:id',
    view: EventDetail,
    layout: 'app',
    accountType: 'master',
    title: 'Event Detail'
  },
  {
    path: '/accounts',
    view: Accounts,
    layout: 'app',
    accountType: 'master',
    title: 'Accounts'
  },
  {
    path: '/users',
    view: Users,
    layout: 'app',
    accountType: 'master',
    title: 'Users'
  },
  {
    path: '/users/:id',
    view: UserDetail,
    layout: 'app',
    accountType: 'master',
    title: 'User Detail'
  },
  {
    path: '/workspaces',
    view: WorkspacesList,
    layout: 'app',
    accountType: 'master',
    title: 'Workspaces'
  },
  {
    path: '/workspaces/:id',
    view: WorkspaceDetail,
    layout: 'app',
    accountType: 'master',
    title: 'Workspace Detail'
  }
];

export default Routes;